import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import FingerprintTwoToneIcon from '@mui/icons-material/FingerprintTwoTone';
import PasswordTwoToneIcon from '@mui/icons-material/PasswordTwoTone';
import { Box, Step, StepLabel, Stepper } from '@mui/material';
import PropTypes from 'prop-types';

const steps = [
  { label: 'የኢሜይል አድራሻዎን ያስገቡ', icon: <EmailTwoToneIcon /> },
  { label: 'የማረጋገጫ ኮዱን ያስገቡ', icon: <FingerprintTwoToneIcon /> },
  { label: 'አዲስ የይለፍ ቃል ያዘጋጁ', icon: <PasswordTwoToneIcon /> },
];

export default function PasswordResetStep({ activeStep }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map(({ label, icon }, index) => (
          <Step key={label}>
            <StepLabel
              icon={icon}
              sx={{
                color: index <= activeStep ? 'teal' : 'inherit',
              }}
            >
              <Box
                sx={{
                  color: index <= activeStep ? 'teal' : 'inherit',
                }}
              >
                {label}
              </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

PasswordResetStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
};
